import { EmployeeAccessLevel } from '../../organization/dto/Employee';
import { UserStats } from '../../recovery/dto/UserStats';

export interface EmployeeCrudDTO {
  id?: number;
  name?: string;
  family?: string;
  companyName?: string;
  position?: string;
  mail?: string;
  phone?: string;
  accessLevel?: EmployeeAccessLevel;
  kpiAccessLevel?: EmployeeAccessLevel;
  financialStatementAccessLevel?: EmployeeAccessLevel;
  accessStatus?: string;
  uuid?: string;
  photo?: string;
  idCompany?: number;
  portalAdminAccess?: boolean;
  kpiNotification?: boolean;
  portfolioNotification?: boolean;
  lastNotification?: Date;
  portalPdf?: boolean;
  marketAnalysis?: boolean;
  dataRoomAccess?: boolean;
  kpis?: boolean;
  organizationAdmin?: boolean;
  orgId?: number;
  userStats?: UserStats;
}

export const TEAM_SORT = {
  byName: (employee: EmployeeCrudDTO): string => employee.name,
  byWorkSpace: (employee: EmployeeCrudDTO): string => employee.companyName,
  byPosition: (employee: EmployeeCrudDTO): string => employee.position,
  byEmail: (employee: EmployeeCrudDTO): string => employee.mail,
  byPhone: (employee: EmployeeCrudDTO): string => employee.phone,
  byFmsAccessLevel: (employee: EmployeeCrudDTO): string => employee.accessLevel,
  byKPIAccessLevel: (employee: EmployeeCrudDTO): string => employee.kpiAccessLevel,
  byPortalPdfAccessLevel: (employee: EmployeeCrudDTO): boolean => employee.portalPdf,
  byPortalAccessLevel: (employee: EmployeeCrudDTO): boolean => employee.portalAdminAccess,
  byDataRoomAccessLevel: (employee: EmployeeCrudDTO): boolean => employee.dataRoomAccess,
  byMarketAnalysisAccessLevel: (employee: EmployeeCrudDTO): boolean => employee.marketAnalysis,
  byFinancialStatementAccessLevel: (employee: EmployeeCrudDTO): string => employee.financialStatementAccessLevel,
  byDocumentsUploaded: (employee: EmployeeCrudDTO): boolean => employee.portfolioNotification,
  byKpiSubmitted: (employee: EmployeeCrudDTO): boolean => employee.kpiNotification,
};
